import { useState } from "react";

function IPhone18ProMaxInfo() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="detail-info">
      <h1 style={{textAlign: 'center', fontSize: '30px'}}>
        <strong>iPhone 18 Pro Max</strong>
      </h1>

      <div className={`content ${showMore ? "expanded" : "collapsed"}`}>
        <p>
          <strong>iPhone 18 Pro Max</strong> là phiên bản màn hình lớn trong
          dòng iPhone 18 Pro, hướng đến người dùng ưu tiên không gian hiển thị
          rộng, thời lượng pin dài và trải nghiệm cao cấp cho giải trí, chơi game
          lẫn sáng tạo nội dung. Máy sở hữu màn hình Super Retina XDR 6,9 inch
          ProMotion 120Hz, chip A20 Pro, hệ thống ba camera 48MP Pro Fusion và
          camera trước 18MP Center Stage.
        </p>

        <p>
          So với iPhone 18 Pro, phiên bản Pro Max giữ nguyên phần lớn công nghệ
          cốt lõi về chip và camera nhưng có lợi thế rõ rệt về màn hình và pin.
          Apple công bố thời gian xem video trên iPhone 18 Pro Max lên đến 43
          giờ, phù hợp với người thường xuyên sử dụng điện thoại cường độ cao
          hoặc muốn giảm tần suất sạc trong ngày.
        </p>

        {showMore && (
          <>
            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro Max có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/tong-hop-cac-tinh-nang-cua-iphone-18-tu-choi-game-toi-dung-co-ban.webp"
                alt="tong-hop-cac-tinh-nang-cua-iphone-18-tu-choi-game-toi-dung-co-ban"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Những nâng cấp đáng chú ý trên iPhone 18 Pro Max tập trung vào
              camera, hiệu năng, AI, hệ thống tản nhiệt và thời lượng pin. Camera
              chính 48MP hỗ trợ khẩu độ thay đổi, chip A20 Pro kết hợp GPU 7 lõi
              và Bộ Đôi Neural Engine 16 lõi, trong khi buồng hơi thế hệ mới
              hướng đến khả năng duy trì hiệu năng tốt hơn khi xử lý tác vụ
              nặng.
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Hạng mục
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro Max
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Super Retina XDR OLED 6,9 inch
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Độ phân giải
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    2868 x 1320 pixel, 460 ppi
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Tần số quét
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    ProMotion thích ứng lên đến 120Hz
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Apple A20 Pro
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    CPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6 lõi
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    GPU
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    7 lõi với Neural Accelerators
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    AI
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Bộ Đôi Neural Engine 16 lõi, Apple Intelligence và Siri AI
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera chính
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Main, khẩu độ thay đổi
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera Ultra Wide
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Ultra Wide
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera Telephoto
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Fusion Telephoto, 4x và 8x chất lượng quang học
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera trước
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    18MP Center Stage
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Dung lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB, 512GB, 1TB, 2TB
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Trọng lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    249g
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Thời gian xem video
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 43 giờ
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sạc nhanh
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Lên đến 50% trong khoảng 15 phút với bộ tiếp hợp tương thích
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màu sắc
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Đen, Bạc, Băng Thanh, Đỏ Burgundy
                  </td>
                </tr>
              </tbody>
            </table>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Màn hình 6,9 inch là lợi thế lớn của iPhone 18 Pro Max
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-co-dynamic-island-nho-hon-dang-ke.webp"
                alt="iphone-18-pro-max-co-dynamic-island-nho-hon-dang-ke"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max sở hữu màn hình{" "}
              <strong>Super Retina XDR OLED 6,9 inch</strong> với độ phân giải
              2868 x 1320 pixel và mật độ điểm ảnh 460 ppi.
            </p>

            <p>
              Đây là khác biệt dễ nhận thấy nhất khi đặt Pro Max cạnh iPhone 18
              Pro 6,3 inch. Không gian hiển thị lớn hơn phù hợp với người thường
              xuyên xem video, chơi game, đọc tài liệu, chỉnh sửa ảnh hoặc làm
              việc trực tiếp trên smartphone.
            </p>

            <p>
              Công nghệ ProMotion hỗ trợ tốc độ làm mới thích ứng lên đến 120Hz,
              giúp các chuyển động trên giao diện và nội dung tương thích hiển
              thị mượt hơn. Màn hình còn hỗ trợ Always-On Display, HDR, True
              Tone, dải màu rộng P3 và Dynamic Island.
            </p>

            <p>
              Độ sáng ngoài trời tối đa đạt 3.000 nit, giúp màn hình duy trì khả
              năng quan sát tốt hơn trong điều kiện ánh sáng mạnh.
            </p>

            <h3>
              <strong>
                Màn hình lớn phù hợp hơn cho giải trí và công việc
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-choi-game-the-gioi-mo.webp"
                alt="iphone-18-pro-max-choi-game-the-gioi-mo"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Không gian 6,9 inch mang lại lợi thế khi xem phim hoặc chơi game
              vì nội dung được hiển thị lớn hơn. Với creator, màn hình rộng cũng
              thuận tiện hơn khi kiểm tra ảnh, timeline video hoặc các chi tiết
              giao diện trong ứng dụng chỉnh sửa.
            </p>

            <p>
              Đổi lại, Pro Max có kích thước và trọng lượng lớn hơn. Đây là yếu
              tố người dùng nên cân nhắc nếu thường xuyên sử dụng điện thoại
              bằng một tay.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Thiết kế iPhone 18 Pro Max có gì đáng chú ý?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-tren-tay-ngoai-duong.webp"
                alt="iphone-18-pro-max-tren-tay-ngoai-duong"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max có kích thước 163,4 x 78 x 8,75 mm và trọng
              lượng 249g. Máy sử dụng thiết kế nguyên khối nhôm, Ceramic Shield
              2 ở mặt trước và Ceramic Shield ở mặt sau.
            </p>

            <p>
              Thiết bị đạt chuẩn IP68 theo IEC 60529 trong điều kiện thử nghiệm
              của Apple.
            </p>

            <p>
              Kích thước lớn mang lại không gian cho màn hình và pin, nhưng cũng
              khiến Pro Max nặng hơn iPhone 18 Pro. Vì vậy, đây không đơn thuần
              là phiên bản “tốt hơn”, mà là lựa chọn phù hợp với nhóm người dùng
              ưu tiên trải nghiệm màn hình lớn và thời lượng sử dụng.
            </p>

            <h3>
              <strong>iPhone 18 Pro Max có những màu nào?</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iPhone-18-Pro-Max-mau-xanh.webp"
                alt="iPhone-18-Pro-Max-mau-xanh"
                style={{ width: "100%" }}
              />
            </figure>

            <p>Apple cung cấp bốn lựa chọn màu:</p>

            <ul>
              <li>
                <strong>Đen:</strong> trung tính và dễ phối phụ kiện.
              </li>
              <li>
                <strong>Bạc:</strong> phong cách sáng và tối giản.
              </li>
              <li>
                <strong>Băng Thanh:</strong> nhẹ nhàng nhưng khác biệt hơn các
                màu truyền thống.
              </li>
              <li>
                <strong>Đỏ Burgundy:</strong> lựa chọn nổi bật cho người muốn
                tạo dấu ấn rõ hơn.
              </li>
            </ul>

            <p>
              Cả bốn màu đều có đầy đủ các phiên bản dung lượng, vì vậy lựa chọn
              màu không ảnh hưởng đến cấu hình.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Chip A20 Pro trên iPhone 18 Pro Max mạnh thế nào?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/Chip-a20-pro-voi-7-core-gpu.webp"
                alt="Chip-a20-pro-voi-7-core-gpu"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max sử dụng <strong>chip A20 Pro</strong> với CPU 6
              lõi gồm 2 lõi hiệu năng cao và 4 lõi tiết kiệm điện. GPU 7 lõi tích
              hợp Neural Accelerators, kết hợp với Bộ Đôi Neural Engine 16 lõi
              để xử lý các tác vụ AI.
            </p>

            <p>
              Cấu hình này hướng đến nhiều nhóm workload khác nhau như chơi game
              đồ họa cao, dựng video, xử lý ảnh và các tính năng Apple
              Intelligence trên thiết bị.
            </p>

            <p>
              Apple còn sử dụng công nghệ đóng gói chip lấy cảm hứng từ dòng M
              nhằm tối ưu đường truyền nhiệt và hỗ trợ hiệu suất trong các tác
              vụ kéo dài.
            </p>

            <h3>
              <strong>
                Buồng hơi thế hệ mới hỗ trợ tác vụ nặng lâu hơn
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/chip-a20-pro-voi-6-core-cpu.webp"
                alt="chip-a20-pro-voi-6-core-cpu"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max được trang bị hệ thống tản nhiệt buồng hơi thế
              hệ mới. Mục tiêu của hệ thống này không chỉ là làm máy mát hơn mà
              còn hỗ trợ chip duy trì hiệu năng tốt hơn khi xử lý game, video
              hoặc workload AI trong thời gian dài.
            </p>

            <p>
              Đây đặc biệt là lợi thế phù hợp với Pro Max, bởi màn hình lớn và
              pin dài khiến thiết bị có xu hướng được sử dụng nhiều hơn cho
              gaming, media và các tác vụ chuyên sâu.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Apple Intelligence và Siri AI trên iPhone 18 Pro Max
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-tinh-chinh-giong-noi-cua-siri-ai.webp"
                alt="iphone-18-pro-max-tinh-chinh-giong-noi-cua-siri-ai"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              A20 Pro cùng Neural Accelerators và Bộ Đôi Neural Engine 16 lõi
              cung cấp nền tảng phần cứng cho Apple Intelligence thế hệ mới.
            </p>

            <p>
              Siri AI được Apple định hướng trở thành trợ lý cá nhân mạnh hơn,
              có khả năng giao tiếp tự nhiên và hiểu ngữ cảnh tốt hơn. AI cũng
              được tích hợp vào nhiều ứng dụng và tác vụ trong hệ thống.
            </p>

            <p>
              Tuy nhiên, khả năng sử dụng từng tính năng còn phụ thuộc vào lịch
              phát hành phần mềm và ngôn ngữ hỗ trợ. Siri AI mới hiện được Apple
              công bố sẽ ra mắt trước bằng tiếng Anh.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Camera iPhone 18 Pro Max có gì mới?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/cong-nghe-camera-ben-trong-iphone-18-pro-max.webp"
                alt="cong-nghe-camera-ben-trong-iphone-18-pro-max"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max sử dụng hệ thống{" "}
              <strong>48MP Pro Fusion</strong> gồm ba camera sau: Fusion Main,
              Fusion Ultra Wide và Fusion Telephoto.
            </p>

            <p>
              Đáng chú ý nhất là camera Main hỗ trợ khẩu độ thay đổi, trong khi
              Telephoto cung cấp mức 4x và 8x chất lượng quang học. Điều này mở
              rộng khả năng kiểm soát hình ảnh từ góc rộng, macro đến chân dung
              và chủ thể ở khoảng cách xa.
            </p>

            <h3>
              <strong>
                Camera 48MP Fusion Main hỗ trợ 4 mức khẩu độ
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-chup-anh-chuyen-nghiep-nho-dieu-chinh-camera-thu-cong.webp"
                alt="iphone-18-pro-max-chup-anh-chuyen-nghiep-nho-dieu-chinh-camera-thu-cong"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera chính 48MP có tiêu cự 24mm và hỗ trợ bốn mức khẩu độ gồm{" "}
              <strong>ƒ/1,48, ƒ/1,8, ƒ/2,8 và ƒ/4,0</strong>.
            </p>

            <p>
              Khẩu độ lớn có thể hỗ trợ thu nhiều ánh sáng hơn, trong khi khẩu
              độ nhỏ hơn có thể mở rộng vùng ảnh rõ trong những tình huống phù
              hợp.
            </p>

            <p>
              Khả năng thay đổi khẩu độ giúp hệ thống camera linh hoạt hơn khi
              xử lý ánh sáng và độ sâu trường ảnh, thay vì chỉ sử dụng một mức
              khẩu độ cố định.
            </p>

            <h3>
              <strong>Camera Ultra Wide 48MP hỗ trợ macro</strong>
            </h3>

            <p>
              Camera Fusion Ultra Wide có độ phân giải 48MP, tiêu cự 13mm, khẩu
              độ ƒ/2,2 và trường nhìn 120 độ.
            </p>

            <p>
              Camera phù hợp với phong cảnh, kiến trúc, ảnh nhóm hoặc những tình
              huống cần góc nhìn rộng. Chế độ macro hỗ trợ ghi lại các chủ thể ở
              khoảng cách gần.
            </p>

            <h3>
              <strong>Telephoto 48MP hỗ trợ zoom 4x và 8x</strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-co-camera-chinh-48mp-co-kha-nang-dieu-chinh-tieu-cu.webp"
                alt="iphone-18-pro-max-co-camera-chinh-48mp-co-kha-nang-dieu-chinh-tieu-cu"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Camera Fusion Telephoto 48MP sử dụng thiết kế tetraprism và hỗ trợ
              tiêu cự tương đương 100mm ở mức 4x.
            </p>

            <p>
              Hệ thống đồng thời cung cấp mức{" "}
              <strong>8x chất lượng quang học</strong> tương đương tiêu cự 200mm,
              phù hợp với chân dung, sự kiện, sân khấu hoặc các chủ thể ở xa.
            </p>

            <p>
              Điểm quan trọng là iPhone 18 Pro Max và iPhone 18 Pro sử dụng hệ
              thống camera cốt lõi tương đồng. Người dùng không cần chọn Pro Max
              chỉ để có camera tốt hơn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Camera trước 18MP Center Stage</strong>
            </h2>

            <p>
              Camera trước của iPhone 18 Pro Max có độ phân giải{" "}
              <strong>18MP Center Stage</strong>, khẩu độ ƒ/1,9 và hỗ trợ tự động
              lấy nét.
            </p>

            <p>
              Center Stage có thể điều chỉnh khung hình theo chủ thể trong các
              tình huống phù hợp. Camera trước còn hỗ trợ quay video, selfie và
              gọi video với khả năng theo dõi chủ thể tốt hơn.
            </p>

            <p>
              Ghi Hình Kép cho phép sử dụng camera trước và camera sau đồng thời,
              hữu ích với vlog, phỏng vấn hoặc những dạng nội dung cần ghi lại
              cả người quay và bối cảnh phía trước.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                iPhone 18 Pro Max quay video có gì nổi bật?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-quay-video-co-kha-nang-focus-vao-1-nguoi-cu-the.webp"
                alt="iphone-18-pro-max-quay-video-co-kha-nang-focus-vao-1-nguoi-cu-the"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              iPhone 18 Pro Max hướng mạnh đến creator với nhiều công cụ quay
              video chuyên nghiệp.
            </p>

            <ul>
              <li>
                Quay 4K Dolby Vision lên đến 120 fps bằng camera Fusion Main.
              </li>
              <li>
                ProRes lên đến 4K 120 fps khi ghi vào ổ đĩa ngoài tương thích.
              </li>
              <li>ProRes RAW.</li>
              <li>Apple Log 2.</li>
              <li>ACES.</li>
              <li>Genlock.</li>
              <li>Ghi Hình Kép lên đến 4K Dolby Vision 30 fps.</li>
              <li>Bốn micrô chuẩn phòng thu.</li>
            </ul>

            <p>
              Với người dùng thông thường, các chế độ Dolby Vision và chống rung
              có thể được khai thác trực tiếp hơn. ProRes RAW, Apple Log 2 và
              Genlock hướng nhiều hơn đến filmmaker hoặc creator có workflow hậu
              kỳ chuyên sâu.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Pin iPhone 18 Pro Max dùng được bao lâu?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/pin-iphone-18-pro-max-thoi-luong-dung-video.webp"
                alt="pin-iphone-18-pro-max-thoi-luong-dung-video"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Pin là một trong những lợi thế lớn nhất của phiên bản Pro Max.
            </p>

            <p>Theo Apple, iPhone 18 Pro Max có:</p>

            <ul>
              <li>Thời gian sử dụng thông thường lên đến 29 giờ.</li>
              <li>
                Thời gian xem video lên đến <strong>43 giờ</strong>.
              </li>
              <li>Thời gian xem video trực tuyến lên đến 38 giờ.</li>
            </ul>

            <p>
              Apple cũng cho biết thời gian xem video trên iPhone 18 Pro Max dài
              hơn đến 6 giờ so với iPhone 17 Pro Max.
            </p>

            <p>
              Thời lượng thực tế sẽ thay đổi theo độ sáng màn hình, mạng di
              động, game, camera và các ứng dụng được sử dụng. Tuy nhiên, xét
              trong cùng dòng iPhone 18 Pro, Pro Max vẫn là lựa chọn rõ ràng hơn
              nếu pin là tiêu chí hàng đầu.
            </p>

            <h3>
              <strong>
                Sạc nhanh lên đến 50% trong khoảng 15 phút
              </strong>
            </h3>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-5-phut-sac-xem-phim-duoc-6-tieng.webp"
                alt="iphone-18-pro-max-5-phut-sac-xem-phim-duoc-6-tieng"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Máy hỗ trợ sạc lên đến 50% trong khoảng 15 phút khi sử dụng bộ
              tiếp hợp tương thích từ 60W trở lên cùng cáp USB-C phù hợp.
            </p>

            <p>
              MagSafe cũng hỗ trợ sạc không dây, mang lại lựa chọn linh hoạt hơn
              khi sử dụng cùng phụ kiện tương thích.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro Max có những dung lượng nào?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/tong-hop-thong-so-ky-thuat-ben-trong-iphone-18-pro-max.webp"
                alt="tong-hop-thong-so-ky-thuat-ben-trong-iphone-18-pro-max"
                style={{ width: "100%" }}
              />
            </figure>

            <p>Apple cung cấp bốn mức dung lượng lưu trữ:</p>

            <ul>
              <li>
                <strong>256GB:</strong> phù hợp với phần lớn nhu cầu hàng ngày và
                người thường xuyên sử dụng cloud.
              </li>
              <li>
                <strong>512GB:</strong> cân bằng hơn cho người quay chụp nhiều,
                chơi nhiều game và sử dụng máy dài hạn.
              </li>
              <li>
                <strong>1TB:</strong> phù hợp với creator hoặc người thường
                xuyên lưu video chất lượng cao.
              </li>
              <li>
                <strong>2TB:</strong> hướng đến workload chuyên nghiệp và người
                muốn giữ lượng dữ liệu rất lớn trực tiếp trên máy.
              </li>
            </ul>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Dung lượng
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Phù hợp với nhu cầu
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    256GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Sử dụng hàng ngày, ảnh/video thông thường, cloud
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    512GB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Quay chụp nhiều, game lớn, sử dụng dài hạn
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    1TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Creator, video 4K, nhiều dữ liệu offline
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    2TB
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Workflow video chuyên nghiệp, lượng dữ liệu rất lớn
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Dung lượng không làm thay đổi chip hay camera. Vì vậy, nên lựa
              chọn dựa trên nhu cầu lưu trữ thực tế thay vì mặc định chọn mức
              cao nhất.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>
                iPhone 18 Pro Max và iPhone 18 Pro khác nhau gì?
              </strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/thoi-luong-pin-moi-lan-sac-cua-iphone-18-pro-va-iphone-18-pro-max.webp"
                alt="thoi-luong-pin-moi-lan-sac-cua-iphone-18-pro-va-iphone-18-pro-max"
                style={{ width: "100%" }}
              />
            </figure>

            <p>
              Hai model chia sẻ phần lớn cấu hình quan trọng. Cả hai đều sử dụng
              A20 Pro, GPU 7 lõi, ba camera 48MP Pro Fusion, camera trước 18MP
              Center Stage và cùng các mức dung lượng.
            </p>

            <p>
              Khác biệt lớn nhất nằm ở{" "}
              <strong>
                màn hình, kích thước, trọng lượng và thời lượng pin
              </strong>
              .
            </p>

            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginBottom: "16px",
              }}
            >
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Tiêu chí
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    iPhone 18 Pro Max
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6,3 inch
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    6,9 inch
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Trọng lượng
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    211g
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    249g
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Chip
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    A20 Pro
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Camera
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Pro Fusion
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    48MP Pro Fusion
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Xem video tối đa
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    34 giờ
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    43 giờ
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Ưu thế chính
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Gọn hơn
                  </td>
                  <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Màn hình lớn, pin dài hơn
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Nếu ưu tiên sự gọn nhẹ, iPhone 18 Pro hợp lý hơn. Nếu màn hình và
              thời lượng pin là những yếu tố quan trọng trong trải nghiệm hàng
              ngày, Pro Max có lợi thế rõ rệt.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>iPhone 18 Pro Max phù hợp với ai?</strong>
            </h2>

            <figure>
              <img
                src="https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro-max/iphone-18-pro-max-va-he-sinh-thai-san-pham-apple.webp"
                alt="iphone-18-pro-max-va-he-sinh-thai-san-pham-apple"
                style={{ width: "100%" }}
              />
            </figure>

            <ul>
              <li>
                <strong>Người ưu tiên pin:</strong> thời gian xem video được
                Apple công bố lên đến 43 giờ.
              </li>
              <li>
                <strong>Người thích màn hình lớn:</strong> không gian 6,9 inch
                phù hợp cho video, game và công việc.
              </li>
              <li>
                <strong>Gamer:</strong> màn hình lớn, ProMotion 120Hz, A20 Pro và
                hệ thống tản nhiệt hỗ trợ trải nghiệm tác vụ nặng.
              </li>
              <li>
                <strong>Creator:</strong> ba camera 48MP, ProRes RAW, Apple Log 2
                và màn hình lớn thuận tiện hơn khi kiểm tra nội dung.
              </li>
              <li>
                <strong>Người dùng cường độ cao:</strong> màn hình và pin tạo lợi
                thế khi điện thoại là thiết bị chính trong ngày.
              </li>
              <li>
                <strong>Người muốn dung lượng lớn:</strong> lựa chọn lên đến 2TB
                phù hợp với nhu cầu lưu trữ chuyên sâu.
              </li>
            </ul>

            <h2>
              <strong style={{fontSize: '22px'}}>
                Ai nên chọn iPhone 18 Pro thay vì Pro Max?
              </strong>
            </h2>

            <p>
              Pro Max không nhất thiết phù hợp với tất cả người dùng.
            </p>

            <p>
              Nếu ưu tiên thiết bị dễ cầm, nhẹ hơn và thuận tiện khi sử dụng bằng
              một tay, iPhone 18 Pro 6,3 inch có lợi thế rõ ràng hơn. Người dùng
              vẫn có A20 Pro và hệ thống camera Pro Fusion cốt lõi mà không phải
              mang theo thân máy 249g.
            </p>

            <p>
              Do đó, quyết định giữa Pro và Pro Max nên dựa trên màn hình và pin
              nhiều hơn là suy nghĩ rằng Pro Max luôn có camera hoặc hiệu năng
              tốt hơn.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Có nên đặt cọc iPhone 18 Pro Max?</strong>
            </h2>

            <p>
              iPhone 18 Pro Max đáng cân nhắc với người muốn tối đa hóa trải
              nghiệm màn hình và pin trong dòng iPhone 18 Pro. Máy vẫn sở hữu
              đầy đủ các nâng cấp về A20 Pro, camera 48MP khẩu độ thay đổi,
              Telephoto 8x và camera trước 18MP Center Stage.
            </p>

            <p>
              Điểm tạo ra khác biệt lớn nhất so với iPhone 18 Pro là màn hình
              6,9 inch và thời gian xem video lên đến 43 giờ. Đây là hai lợi thế
              có thể cảm nhận trực tiếp mỗi ngày nếu người dùng thường xuyên xem
              nội dung, chơi game, làm việc hoặc quay dựng trên điện thoại.
            </p>

            <p>
              Trước khi đặt cọc, người dùng nên xác định ba yếu tố chính: có thực
              sự cần màn hình 6,9 inch hay không, mức dung lượng phù hợp và việc
              trọng lượng 249g có ảnh hưởng đến thói quen sử dụng. Giá, chính
              sách đặt cọc và ưu đãi nên được kiểm tra trực tiếp tại ShopDunk
              theo từng thời điểm.
            </p>

            <h2>
              <strong style={{fontSize: '22px'}}>Câu hỏi thường gặp về iPhone 18 Pro Max</strong>
            </h2>

            <h3>
              <strong>
                iPhone 18 Pro Max màn hình bao nhiêu inch?
              </strong>
            </h3>
            <p>
              Máy sử dụng màn hình Super Retina XDR OLED 6,9 inch với ProMotion
              và tốc độ làm mới thích ứng lên đến 120Hz.
            </p>

            <h3>
              <strong>iPhone 18 Pro Max dùng chip gì?</strong>
            </h3>
            <p>
              iPhone 18 Pro Max sử dụng chip A20 Pro với CPU 6 lõi, GPU 7 lõi
              tích hợp Neural Accelerators và Bộ Đôi Neural Engine 16 lõi.
            </p>

            <h3>
              <strong>
                Pin iPhone 18 Pro Max dùng được bao lâu?
              </strong>
            </h3>
            <p>
              Theo Apple, máy có thời gian xem video lên đến 43 giờ và xem video
              trực tuyến lên đến 38 giờ. Thời lượng thực tế phụ thuộc vào cách
              sử dụng.
            </p>

            <h3>
              <strong>iPhone 18 Pro Max có zoom 8x không?</strong>
            </h3>
            <p>
              Có. Camera Fusion Telephoto hỗ trợ mức 4x tương đương 100mm và mức
              8x chất lượng quang học tương đương tiêu cự 200mm.
            </p>

            <h3>
              <strong>
                Camera iPhone 18 Pro Max có khác iPhone 18 Pro không?
              </strong>
            </h3>
            <p>
              Hai model sử dụng hệ thống camera Pro Fusion cốt lõi tương đồng,
              gồm Main 48MP, Ultra Wide 48MP và Telephoto 48MP. Khác biệt chính
              giữa hai máy không nằm ở camera mà ở kích thước màn hình và pin.
            </p>

            <h3>
              <strong>
                iPhone 18 Pro Max có những dung lượng nào?
              </strong>
            </h3>
            <p>
              Apple cung cấp bốn tùy chọn gồm 256GB, 512GB, 1TB và 2TB.
            </p>

            <h3>
              <strong>iPhone 18 Pro Max nặng bao nhiêu?</strong>
            </h3>
            <p>
              Máy nặng 249g, cao 163,4 mm, rộng 78 mm và dày 8,75 mm.
            </p>

            <h3>
              <strong>Nên chọn iPhone 18 Pro hay Pro Max?</strong>
            </h3>
            <p>
              iPhone 18 Pro phù hợp với người ưu tiên thiết bị nhỏ gọn hơn. Pro
              Max phù hợp hơn nếu màn hình 6,9 inch và thời lượng pin dài là hai
              tiêu chí quan trọng nhất.
            </p>
          </>
        )}
      </div>

      <div className="all-toggle-btn">
        <button
          className="toggle-btn"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Thu gọn" : "Xem thêm"}
        </button>
      </div>

      <style>{`
        .content.collapsed {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .toggle-btn {
          margin-top: 10px;
          padding: 8px 16px;
          border: none;
          border-radius: 80px;
          cursor: pointer;
          background: #037CF6;
          color: #fff;
        }
      `}</style>
    </div>
  );
}

export default IPhone18ProMaxInfo;